import { destroyAdmin, getAdmin, postAdmin, putAdmin } from "../axios/api/AdminBaseUrl"
import { buildQueryString } from "../utils/queryParams"

export const role ={
    list:{
        key:"list",
            call: (page, search, statusFilter, ordering) => {
            const query = buildQueryString({ page, search, status: statusFilter, ordering })
            return getAdmin(`/admin/role/?${query}`)
          }
    },
    rolelist:{
      key:"rolelist",
      call: () => {
          return getAdmin(`/role_permissions/`)
        }
  },
      delete:{
        key: "delete",
        call:(id)=>{ return destroyAdmin(`/admin/role/${id}/`);
    }
    },
    add:{
      key: "add",
      call:(payload)=>{ return postAdmin(`/admin/role/`,payload);
    }
    },
    update:{
      key: "update",
      call:(id, payload)=>{ return putAdmin(`/admin/role/${id}/`,payload);
    }
  },
  Permissionslist:{
    key:"Permissionslist",
    call: (id) => {
      return getAdmin(`/admin/role/${id}/`)
    }
  }


}
